import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
// import { useCallback, useContext } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';

// import {Context} from "@router/Sound";
import { useTranslation } from 'react-i18next';
import { useMobxStores } from '@stores/store';
import { isEmpty as _isEmpty } from 'lodash';
import { isIOS, isMobile, comTracking, POLICY_SITE } from '@helpers/EnvHelper';
import { useWindowSize } from 'usehooks-ts';
import './index.scss';
import GdprDialog from '@molecules/modal/dialog/GdprDialog';
import GdprDetailDialog from '@molecules/modal/dialog/GdprDetailDialog';
import moment from 'moment/moment';
import { consentCookiesKey } from '@stores/SettingStore';
import { getStringFromJson } from '@helpers/Util';
import LanguageBox from '@organisms/common/LanguageBox';
import { countryCodeToLanguage } from '@helpers/EnvHelper';

const Footer = () => {
  const { settingStore } = useMobxStores();
  const { t, i18n } = useTranslation();
  const { width } = useWindowSize();
  const location = useLocation();

  useEffect(() => {
    //console.log(location);
    getContentsCookiesStatus();
  }, [getContentsCookiesStatus, location]);

  const getContentsCookiesStatus = () => {
    let expireTime = getStringFromJson(
      localStorage.getItem(consentCookiesKey.expire)
    );
    let now = moment(new Date().getTime()).unix();

    if (expireTime) {
      settingStore.setGdprDialogState(false);
      if (expireTime < now) {
        localStorage.removeItem(consentCookiesKey.cookies);
        localStorage.removeItem(consentCookiesKey.times);
        localStorage.removeItem(consentCookiesKey.expire);
        settingStore.setGdprDialogState(true);
      }
    } else {
      settingStore.setGdprDialogState(true);
    }
  };

  const onOpenCookies = () => {
    settingStore.setGdprDetailDialogState(true);
  };

  return (
    <footer className="bg-[#000000] min-h-[212px] py-[50px] px-cpx xl:px-[50px] text-white text-opacity-50 text-[14px] leading-[1.79]">
      <div className="absolute right-[30px] z-[89]">
        <LanguageBox />
      </div>
      <div className="max-w-[1920px] mx-auto flex relative flex-col justify-center">
        <div className="footer-info">
          <div>
            {/* <a href="#"> */}
            <img
              className="max-w-[96px]"
              src="/img/logo-hybeim.png"
              srcSet="/img/logo-hybeim@2x.png 2x,
                          /img/logo-hybeim@3x.png 3x"
            />
            {/* </a> */}
          </div>
          <ul
            className={classnames(
              'mt-[13px] mb-[20px] text-white flex items-center',
              'xl:divide-x xl:divide-gray-400 xl:mt-[20px] xl:mb-[15px]'
            )}
          >
            <li
              className={classnames(
                'px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                href={`${POLICY_SITE}/${
                  countryCodeToLanguage[i18n.language] || 'en'
                }/policies/terms-of-service`}
                target="_blank"
              >
                {t('이용약관')}
              </a>
            </li>
            <li
              className={classnames(
                'px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                href={`${POLICY_SITE}/${
                  countryCodeToLanguage[i18n.language] || 'en'
                }/policies/privacy-policy`}
                className="font-bold"
                target="_blank"
              >
                {t('개인정보처리방침')}
              </a>
            </li>
            <li
              className={classnames(
                'px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a href={t('CUSTOM_LINK')} target="_blank" rel="noreferrer">
                {t('고객센터')}
              </a>
            </li>
            <li
              className={classnames(
                'hidden xs:block px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                href={`${POLICY_SITE}/${
                  countryCodeToLanguage[i18n.language] || 'en'
                }/policies/cookie-policy`}
                target="_blank"
                rel="noreferrer"
              >
                {t('쿠키 정책')}
              </a>
            </li>
            <li
              className={classnames(
                'hidden xs:block px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                onClick={onOpenCookies}
                rel="noreferrer"
                className={'cursor-pointer'}
              >
                {t('쿠키 설정')}
              </a>
            </li>
            {i18n.language == 'kr' && (
              <li
                className={classnames(
                  'hidden xs:block px-[15px] first:pl-0 last:pr-0',
                  'xl:px-[20px] xl:leading-[10px]'
                )}
              >
                <a
                  href={
                    'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8438602224'
                  }
                  rel="noreferrer"
                  target={'_blank'}
                  className={'cursor-pointer'}
                >
                  {t('사업자정보확인')}
                </a>
              </li>
            )}
          </ul>

          {/* 여기 모바일은 깔끔하게 두줄로 나와야해서 두번씩 중복으로 쓰고있습니다. 체크하세여 */}
          <ul
            className={classnames(
              'text-white mt-[13px] mb-[20px] flex items-center block xs:hidden'
            )}
          >
            <li
              className={classnames(
                'px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                href={`/${i18n.language}/policy/cookies`}
                target="_blank"
                rel="noreferrer"
              >
                {t('쿠키 정책')}
              </a>
            </li>
            <li
              className={classnames(
                'px-[15px] first:pl-0 last:pr-0',
                'xl:px-[20px] xl:leading-[10px]'
              )}
            >
              <a
                onClick={onOpenCookies}
                rel="noreferrer"
                className={'cursor-pointer'}
              >
                {t('쿠키 설정')}
              </a>
            </li>
            {i18n.language == 'kr' && (
              <li
                className={classnames(
                  'px-[15px] first:pl-0 last:pr-0',
                  'xl:px-[20px] xl:leading-[10px]'
                )}
              >
                <a
                  href={
                    'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8438602224'
                  }
                  rel="noreferrer"
                  target={'_blank'}
                  className={'cursor-pointer'}
                >
                  {t('사업자정보확인')}
                </a>
              </li>
            )}
          </ul>

          <p>
            <span className="mr-1">
              ⓒ BIGHIT MUSIC / HYBE IM. All Rights Reserved.
            </span>
            <br className="xl:hidden" />
            {t('하이브아이엠 주소')}
          </p>
          <ul
            className={classnames(
              'footerMenu1',
              'mt-[5px] mb-[15px] flex flex-wrap items-center gap-x-[10px]',
              'xl:divide-x xl:divide-gray-500'
            )}
          >
            {[
              `${t('상호')} : ${t('(주)하이브아이엠')}`,
              `${t('통신판매업 신고번호')} : ${t('제 2022-서울강남-01792호')} `,
              `${
                i18n.language == 'kr'
                  ? `${t('대표전화')} : ${t('02-568-1277')}`
                  : ''
              }`,
              `${
                i18n.language == 'kr'
                  ? `${t('이메일')} : ${t('btsisland_support@hybecorp.com')}`
                  : ''
              }`,
              `${t('대표')} : ${t('정우용')}`,
            ].map(
              (e, index) =>
                e !== '' && (
                  <li
                    key={`index-${index}`}
                    className={classnames(
                      'md:first:pl-0 last:pr-0',
                      'xl:leading-[19px] xl:px-[20px]'
                    )}
                  >
                    {e}
                  </li>
                )
            )}
          </ul>
        </div>
        <div className={'items-center'}>
          {!_isEmpty(settingStore.footer) && (
            <ul className=" flex items-center  float-left mt-[20px]">
              {!_isEmpty(settingStore.footer) &&
                settingStore.footer.map((row, index) => (
                  <li key={`footer_${index}`} className={' pr-[25px]'}>
                    <a
                      href={row.webLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={row.iconSrc} alt={row.snsName} />
                    </a>
                  </li>
                ))}
            </ul>
          )}

          <ul className="float-left mt-[10px] flex">
            {(!isMobile() || (isMobile() && isIOS())) && (
              <li className="mr-[5px]">
                <a
                  href={t('iOS_LINK_FOOTER')}
                  onClick={() => comTracking('Lead', t('twttr_track_ios'))}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="h-[40px]"
                    src="/img/down-appstore.png"
                    srcSet="/img/down-appstore@2x.png 2x,
                                  /img/down-appstore@3x.png 3x"
                    alt="app store"
                  />
                </a>
              </li>
            )}
            {(!isMobile() || (isMobile() && !isIOS())) && (
              <li>
                <a
                  href={t('AOS_LINK_FOOTER')}
                  onClick={() => comTracking('Lead', t('twttr_track_aos'))}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="h-[40px]"
                    src="/img/down-googleplay.png"
                    srcSet="/img/down-googleplay@2x.png 2x,
                                    /img/down-googleplay@3x.png 3x"
                    alt="google play"
                  />
                </a>
              </li>
            )}
          </ul>
          <div className="hidden"></div>
        </div>
      </div>

      <GdprDetailDialog />
      {(location.pathname == '/' + i18n.language + '/' ||
        location.pathname == '/') && <GdprDialog />}
    </footer>
  );
};

// const Footer = () => {
//     const { t } = useTranslation();

//     const { isPlay, setIsPlay } = useContext(Context);

//     const onClickPlayMusicButton = useCallback(() => {
//         setIsPlay(!isPlay);
//     }, [isPlay, setIsPlay]);
//     return (
//         <>
//             <footer className="footer">
//                 <div className="inner">
//                     <div className="footer-info">
//                     <div className="logo-group">
//                         <h1>
//                         <a href="#">
//                             <img src="/img/logo-hybe.png" alt="hybe" />
//                         </a>
//                         <a href="#">
//                             <img src="/img/logo-netmarble.png" alt="netmarble" />
//                         </a>
//                         </h1>
//                     </div>
//                     <ul className="sitemenu">
//                         <li><Link to={`/policy/service`}>{t("이용약관")}</Link></li>
//                         <li><Link to={`/policy/privacy`}>개인정보취급방침</Link></li>
//                         <li><Link to={`/policy/operation`}>운영정책</Link></li>
//                         <li><Link to={`#`}>고객센터</Link></li>
//                         <li><Link to={`#`}>앱다운로드</Link></li>
//                     </ul>
//                     <p>COPYRIGHT &copy; HYBE IM. ALL RIGHTS RESERVED.</p>
//                     <ul className="info">
//                         <li>상호: 하이브 아이엠</li>
//                         <li>사업자등록번호: 143-01-09821</li>
//                         <li>대표: 김선일</li>
//                         <li>통신판매업 신고번호 제2015-경기성남-0971</li>
//                     </ul>
//                 </div>
//                 <div className="sns">
//                     <ul>
//                         <li><Link to={`#`}><img src={`/img/logo-facebook.png`} alt="facebook"/></Link></li>
//                         <li><Link to={`#`}><img src={`/img/logo-twitter.png`} alt="twitter"/></Link></li>
//                         <li><Link to={`#`}><img src={`/img/logo-insta.png`} alt="instagram"/></Link></li>
//                         <li><Link to={`#`}><img src={`/img/logo-youtube.png`} alt="youtube"/></Link></li>
//                     </ul>
//                 </div>
//             </div>
//         </footer>
//     </>
//   );
// };

export default observer(Footer);
